import React, { useCallback, useRef } from "react";
import { GeolocateControl as MapboxGeolocateControl } from "mapbox-gl";
import { useTranslation } from "react-i18next";
import { GeolocateControl } from "react-map-gl/mapbox-legacy";
import { MapboxButtonMimic } from "./MapboxButtonMimic";

// This patch was added due to a bug in mapbox-gl's GeolocateControl. React
// intentionally mounts components twice in StrictMode* to help detect potential
// issues with side effects, but GeolocateControl doesn't account for this and
// attempts to access _map before it's available. This patch ensures that
// _setupUI only runs if _map is available, and prevents errors during
// development (and cypress runs).
// See: https://react.dev/reference/react/StrictMode#fixing-bugs-found-by-double-rendering-in-development
const proto = MapboxGeolocateControl.prototype as unknown as {
  _setupUI: (args: unknown) => void;
};
const originalSetupUI = proto._setupUI;
proto._setupUI = function (this: { _map: unknown }, args: unknown) {
  if (this._map) {
    originalSetupUI.call(this, args);
  }
};

export const GeolocationTool = ({
  geolocateClicked,
}: {
  geolocateClicked: () => Promise<void>;
}) => {
  const { t } = useTranslation();
  const geolocateControlRef = useRef<MapboxGeolocateControl>(null);

  const handleClick = useCallback(async () => {
    await geolocateClicked();
    geolocateControlRef.current?.trigger();
  }, [geolocateClicked]);

  return (
    <>
      {/* Hidden GeolocateControl provides access to the trigger() method for
          activating browser geolocation. We render our own button via
          MapboxButtonMimic to control positioning. */}
      <GeolocateControl
        ref={geolocateControlRef}
        trackUserLocation
        fitBoundsOptions={{ maxZoom: 18, minZoom: 18 }}
        position="bottom-right"
        style={{ display: "none" }}
      />
      <MapboxButtonMimic
        showLabel
        buttons={[
          {
            iconClass: "mapboxgl-ctrl-geolocate",
            onClick: handleClick,
            label: t("button-show-location"),
          },
        ]}
      />
    </>
  );
};
